import React, { Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { Checkbox } from "@cxagroup/casper";
import classnames from "classnames";
import { FormattedMessage, intlShape } from "react-intl";
import messages from "components/messagesDescription";
import { changeMemberSelection, changeMemberGroup } from "../../../actions/enrollmentActions";
import {
  getPriceTagging,
  formatMoney,
  isPlanMemberGrouped,
  isPlanPerMembered,
  getMemberGroupByType,
  isPlanWithIntervalOptions,
  getIntervalOptionMemberPrices,
  getAllEligibleMembers,
} from "./EnrollmentDataUtil";

const PlanPerMembers = ({ benefit, plan }) => {
  const dispatch = useDispatch();
  const members = getAllEligibleMembers(plan);
  const hasIntervalOptions = isPlanWithIntervalOptions(plan);
  const memberPriceList = hasIntervalOptions && getIntervalOptionMemberPrices(plan);

  const onMemberChange = e => {
    e.preventDefault();
    const members = e.target.value.split("|");
    dispatch(changeMemberSelection(plan, benefit.benefitID, members[0], members[1]));
  };

  return members.map(member => (
    <div key={member.key}>
      {member.type === "Employee" && members.length > 1 && (
        <div>
          <strong className="member-list--label">
            <FormattedMessage {...messages.employeeNameDescription} />:
          </strong>{" "}
          {member.name}
        </div>
      )}
      {member.key && member.type !== "Employee" && plan.planId !== "0n" && plan.planId !== "0000" && (
        <div className="member-list">
          <Checkbox
            value={member.key + "|" + member.type}
            onChange={onMemberChange}
            checked={member.isSelected}
            disabled={!member.selectable}
            className="member-list--label__item"
          >
            <strong className={classnames({ "member-list--label": member.isAvailable })}>
              <FormattedMessage {...messages.dependantDescription} /> :
            </strong>{" "}
            {member.name}{" "}
          </Checkbox>
          <div className="member-list--item">
            {"+"}{" "}
            {memberPriceList && memberPriceList.length > 0
              ? formatMoney(
                  memberPriceList.find(mp => mp.memberKey === member.key).price.numericValue
                )
              : formatMoney(member.price.numericValue)}
          </div>
        </div>
      )}
    </div>
  ));
};

const PlanMemberGroup = ({ intl, benefit, plan, ...rest }) => {
  const dispatch = useDispatch();
  const priceTagMode = useSelector(state => state.enrollment.details.priceTagMode);

  const PlanPrice = ({ members }) => {
    const pricing = getPriceTagging(priceTagMode, members, plan);
    const priceMode = !pricing.isRelativePrice
      ? "absolute"
      : pricing.relativeTagNode === "Standard"
      ? "standard"
      : "relative";

    return (
      <div>
        <p className="plan-price">
          {priceMode === "absolute" ? (
            <div>
              {pricing.price != 0 &&
                (pricing.price > 0 ? (
                  <FormattedMessage {...messages.enrollment.spendDescription} />
                ) : (
                  <FormattedMessage {...messages.enrollment.creditDescription} />
                ))}
              &nbsp;
              <strong>{formatMoney(Math.abs(pricing.price))}</strong>
            </div>
          ) : priceMode === "relative" ? (
            <div>
              {pricing.price != 0 &&
                (pricing.relativePrice > 0 ? (
                  <FormattedMessage {...messages.enrollment.spendDescription} />
                ) : (
                  <FormattedMessage {...messages.enrollment.creditDescription} />
                ))}
              &nbsp;
              <strong>{formatMoney(Math.abs(pricing.relativePrice))}</strong>
            </div>
          ) : (
            <FormattedMessage {...messages.standardDescription} />
          )}
        </p>
      </div>
    );
  };

  return (
    <Fragment>
      <strong>
        <FormattedMessage {...messages.enrollment.selectMemberLabel} />
      </strong>
      <div className="grid__wrapper plan-container">
        {plan.plans.map(option => {
          const componentCls = classnames("product-plan", "product-plan--selectable", {
            "product-plan--active": option.isSelected,
            "product-plan--disabled": !option.isAvailable,
          });
          return (
            <div key={option.id} className="grid__item grid__item--three product-panel__plan">
              <div className="product-plan-wrapper">
                <div className="product-plan__badges">
                  <div
                    className="product-plan__badge"
                    aria-hidden={option.id !== benefit.benefitOptions.defaultOption.id && "true"}
                  >
                    {option.id === benefit.benefitOptions.defaultOption.id ? (
                      <FormattedMessage {...messages.defaultDescription} />
                    ) : null}
                  </div>
                </div>
                <button
                  type="button"
                  style={{ textAlign: "center" }}
                  onClick={() =>
                    dispatch(changeMemberGroup(plan, benefit.benefitID, option.memberType))
                  }
                  className={componentCls}
                  disabled={!option.isAvailable}
                >
                  <div className="product-plan__details">
                    <span>
                      <strong>{getMemberGroupByType(option.priceLabelName, option.memberType, intl)}</strong>
                    </span>
                    <PlanPrice members={option.eligibleMembers.members} />
                  </div>
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </Fragment>
  );
};

const PlanMembers = ({ benefit, plan, intl }) => {
  if (isPlanPerMembered(plan)) {
    return <PlanPerMembers benefit={benefit} plan={plan} />;
  }
  if (isPlanMemberGrouped(plan)) {
    return <PlanMemberGroup benefit={benefit} plan={plan} intl={intl} />;
  }
  return null;
};

PlanMembers.propTypes = {
  plan: PropTypes.object.isRequired,
  benefit: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
};

PlanMemberGroup.propTypes = {
  plan: PropTypes.object.isRequired,
  benefit: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
};

export default (PlanMembers);



// WEBPACK FOOTER //
// ./components/employee/shop/PlanMembers.js